
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAddSecureGroups(
    GroupListPaging, GroupListService, $timeout, $http, $q, $filter, toastr, GroupListPOSTPaging, GroupFilterModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        tenant: "=resource",
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/secureSettings/addSecureGroups/addSecureGroups.template.html',
      link: function(scope) {

        scope.groupListPaging = new GroupListPOSTPaging();
        scope.requestType = 'POST';
        scope.groupList = [];
        scope.noGroupSelected = true;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        scope.searchString = '';

        (function() {
          customKeyBinding = true;
          prepareGroups();
        })();

        function prepareGroups () {
          var groups = scope.tenant.info._embedded.securePrintConfiguration._embedded[scope.context.groups];
          angular.forEach(groups, function (group) {
            group.options = {}
            group.options.isSelected = false;
          })

          scope.groupsAttached = groups

          scope.filtersList = new GroupFilterModel('SECURE_GROUPS').filters;
        }

        function setExcludes () {
          var excludes = [];

          if (Array.isArray(scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.exclude])) {
            angular.forEach(scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.exclude], function (exclude) {
              excludes.push(exclude.href);
            })
          } else {
            angular.forEach(scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.exclude], function (exclude) {
              excludes.push(exclude);
            })
          }

          return excludes;
        }


        function getFirstGroupsPage() {
          scope.selectedGroups = [];
          scope.unSelectedGroups = [];
          scope.groupListPaging.pagingCriteria.page = 0;
          scope.groupListPaging.pagingCriteria.exclude = scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.exclude] ? setExcludes() : null;
          scope.loadingPage = true;
          scope.groupList = [];

          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function (response) {
            window.scrollTo(0,0);
            scope.totalPages = response.page.totalPages;
            scope.groupList = response.list;
            scope.loadingPage = false;
          }).catch(function(error) {});
        }

        // ADD THROTTLE TO THIS
        scope.textSearch = function () {
          scope.groupListPaging.pagingCriteria.match = scope.searchString;
          getFirstGroupsPage();
        }

        scope.getFirstGroupsPage = function () {
          getFirstGroupsPage();
        }

        function getNextGroupsPage () {
          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.groupListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){
              if (response.list) {
                scope.groupList = scope.groupList.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextGroupsPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.toggleSelectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()
          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.selectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.selectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.toggleUnselectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()

          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.unSelectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.unSelectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.deselectGroup =  function (event, group) {
          if (group.info) {
            for (var i = 0; i < scope.selectedGroups.length; i++) {
              if (group.info._links.self.href === scope.selectedGroups[i].info._links.self.href) {
                scope.selectedGroups.splice(i, 1);
              }
            }
          } else {
            for (var i = 0; i < scope.unSelectedGroups.length; i++) {
              if (group._links.self.href === scope.unSelectedGroups[i]._links.self.href) {
                scope.unSelectedGroups.splice(i, 1);
              }
            }
          }

        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.saveChanges = function () {
          addGroups();
        }

        function addGroups () {
          var url = scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.link].href;
          var groupIDsAdd = [];
          var groupIDsRemove = [];
          angular.forEach(scope.selectedGroups, function(group) {
            groupIDsAdd.push(group.info._links.self.href);
          })

          angular.forEach(scope.unSelectedGroups, function(group) {
            groupIDsRemove.push(group._links.self.href);
          })

          var postObjectAdd = {
            type: 'ADD',
            groups: groupIDsAdd
          }

          var postObjectRemove = {
            type: 'DELETE',
            groups: groupIDsRemove
          }

          if (scope.context.securityLevel) {
            url = url.replace('{securityLevel}', scope.context.securityLevel);
            postObjectAdd.securityLevel = scope.context.securityLevel
          }

          var postObjectWrapper = []
          if (postObjectAdd.groups.length > 0) {
            postObjectWrapper.push(postObjectAdd);
          }

          if (postObjectRemove.groups.length > 0) {
            postObjectWrapper.push(postObjectRemove);
          }

          GroupListService.addSecuritySettingOnGroups(url, postObjectWrapper).then(function() {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });
          scope.callback();

        }

      }
    };
  }

  pxAddSecureGroups.$inject = [
    'GroupListPaging', 'GroupListService', '$timeout', '$http', '$q', '$filter', 'toastr', 'GroupListPOSTPaging', 'GroupFilterModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxAddSecureGroups', pxAddSecureGroups);

})();
